import { createElement, Fragment } from "@wordpress/element";

/**
 * Internal dependencies
 */
import { ItemBadgeUI, ItemTitleUI } from '../styles/navigation-styles';
export default function NavigationItemBaseContent(props) {
  var badge = props.badge,
      title = props.title;
  return createElement(Fragment, null, title && createElement(ItemTitleUI, {
    className: "components-navigation__item-title",
    variant: "body.small",
    as: "span"
  }, title), badge && createElement(ItemBadgeUI, {
    className: "components-navigation__item-badge"
  }, badge));
}
//# sourceMappingURL=base-content.js.map